export default [
    {
        name: 'FRB8S',
        img: require('@/assets/images/products/refill/frb8s.jpg'),
        width: '8.5mm',
        length: '11"-40"<br>28CM-103CM',
        desc: 'Standard/Narrowback Backing<br>W/ Single Edge Rubber<br>(Cut to size)'
    },
    {
        name: 'FRB6S',
        img: require('@/assets/images/products/refill/frb6s.jpg'),
        width: '6.5mm',
        length: '11"-28"<br>28CM-71CM',
        desc: 'Standard/Narrowback Backing<br>W/ Single Edge Rubber<br>(Cut to size)'
    },
    {
        name: 'FRB8M',
        img: require('@/assets/images/products/refill/frb8m.jpg'),
        width: '8.5mm',
        length: '11"-28"',
        desc: 'Standard Backing<br>W/ Multi Edge Rubber<br>(Cut to size)'
    },
    {
        name: 'FRB6M',
        img: require('@/assets/images/products/refill/frb6m.jpg'),
        width: '6.5mm',
        length: '28CM-71CM',
        desc: 'Standard Backing<br>W/ Multi Edge Rubber<br>(Cut to size)'
    },
    {
        name: 'OM7/TNB',
        img: require('@/assets/images/products/refill/om7_tnb.jpg'),
        width: '6.0mm',
        length: '11"-24"<br>28CM-61CM',
        desc: 'Omega type<br>W/ Single Edge Rubber <br>(Cut to size)'
    },
    {
        name: 'RU7',
        img: require('@/assets/images/products/refill/ru7.jpg'),
        width: '6.0mm',
        length: '11"-24"<br>28CM-61CM',
        desc: 'Tapered Type <br>W/ Single Edge Rubber'
    },
    {
        name: 'RU9',
        img: require('@/assets/images/products/refill/ru9.jpg'),
        width: '8.0mm',
        length: '20"-28"<br>51CM-71CM',
        desc: 'Tapered Type <br>W/ Single Edge Rubber'
    },
    {
        name: 'RU7M',
        img: require('@/assets/images/products/refill/ru7m.jpg'),
        width: '6.0mm',
        length: '11"-24"<br>28CM-61CM',
        desc: 'Tapered Type<br>W/ Single Edge Rubber'
    },
    {
        name: 'JS6/G356',
        img: require('@/assets/images/products/refill/js6_g356.jpg'),
        width: '6.0mm',
        length: '10"-24"<br>25CM-61CM',
        desc: 'Square type<br>W/ Single Edge Rubber'
    },
    {
        name: 'JS8',
        img: require('@/assets/images/products/refill/js8.jpg'),
        width: '8.0mm',
        length: '24"-28"<br>61CM-71CM',
        desc: 'Square type<br>W/ Single Edge Rubber'
    },
    {
        name: 'RU2',
        img: require('@/assets/images/products/refill/ru2.jpg'),
        width: '9.0mm',
        length: '20"-40"<br>51CM-100CM',
        desc: 'Tower Type<br>W/ Single Edge Rubber'
    },
    {
        name: 'RC',
        img: require('@/assets/images/products/refill/rc.jpg'),
        width: '10.0mm',
        length: '32"-40"<br>80CM-100CM',
        desc: ''
    },
    {
        name: 'TR',
        img: require('@/assets/images/products/refill/tr.jpg'),
        width: '8.54mm',
        length: '19"-28"<br>48CM-70CM',
        desc: 'Truck Type<br>W/ Single Edge Rubber'
    },
    {
        name: 'DB',
        img: require('@/assets/images/products/refill/db.jpg'),
        width: '8.54mm',
        length: '20"-28"<br>50CM-70CM',
        desc: ''
    },
    {
        name: 'MRN',
        img: require('@/assets/images/products/refill/mrn.jpg'),
        width: '6.0mm',
        length: '24"<br>61CM',
        desc: ''
    },
    {
        name: 'RF',
        img: require('@/assets/images/products/refill/rf.jpg'),
        width: '6.5mm',
        length: '22"-24"<br>56CM-61CM',
        desc: 'Double Blade Type'
    },
]